/*------------------------------------------------------------------
  - This script for adding product for seller to sell his item
  - Contact karthikn503@gmail.com
-------------------------------------------------------------------*/
$( document ).ready(function() {
  
  function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return "";
  }
  
  //Checking seller logged and showing add product button
  if (readCookie('business_name') != null && $('#seller_name').length &&
      readCookie('business_name') == $('#seller_name').val() ){
    $('.seller_add_product').show();
  } 
  
  function validateAgreement() {
 
    if (!(document.getElementById('add_product_seller_agree').checked)) {
      $("#add_product_seller_agree_error").html("Please signify your agreement with our terms.").fadeIn();
      return false;
    }
    return true;
  }
  
  function validateProductImages() {
    $(".error_tag").hide();

    if(product_img_arr.length == 0){
      $("#add_product_image_error").html("Please add at least one image for the product.").fadeIn();
      return false;
    }
    return true;
  }

  //Validating product form
  function productValidation(){
    var decimal=  /^[-+]?[0-9]+\.[0-9]+$/;
     var alphaNumericFormat = /^[a-zA-Z0-9]+$/;
     var alphabetFormat = /^[a-zA-Z]+$/;
    var title = $('#title').val(),
        quantity = $('#quantity').val(),
        
        product_price = $('#product_price').val(),
        product_offer_price = $('#product_offer_price').val(),
        deliveryTimeline = $('#delivery_timeline').val(),
    	weight = $('#product_weight').val(),
        product_description = $('#product_description').val(),
        product_size =$('#size').val(),
        product_color = $('#color').val(),
        product_material = $('#material').val(),
        product_care = $('#productCare').val(),
        product_sku = $('#sku').val(),
        product_label = $('#product_label').val(),
       // product_label = $('#product_label').val().(" ").length - 1,
        product_tags = $('#product_tags').val(),
        product_collections = $('#product_collection').val();
    
	$(".error_tag").hide();
    
    var isvalid = true;
    
    if( title == "" ) {
      $('#title').focus();
      $("#title_error").css({'display':'table'}).html("Please enter title");
      isvalid = false;
    } else if (title.length && title.length > 35) {
      $('#title').focus();
      $("#title_error").css({'display':'table'}).html("Please enter upto 35 characters");
      isvalid = false;
    }
    
     if(product_price == ""){
      $('#product_price').focus();
      $("#product_price_error").css({'display':'table'}).html("Please enter product price");
      isvalid = false;
    } else if(!$.isNumeric(product_price)){
   	  $('#product_price').focus();
      $("#product_price_error").css({'display':'table'}).html("Please enter a valid price ex: 100.00 or 100");
      isvalid = false;
    } else if (parseInt(product_price) <= 0){
      $('#product_price').focus();
      $("#product_price_error").css({'display':'table'}).html("Product price cannot be 0");
      isvalid = false;
    }
    
    if(product_offer_price != ""){
      if(!$.isNumeric(product_offer_price)){
         $('#product_offer_price').focus();
          $("#product_offer_price_error").css({'display':'table'}).html("Please enter a valid price ex: 100.00 or 100");
          isvalid = false;
      } else if(parseInt(product_offer_price) <= 0){
      	 $('#product_offer_price').focus();
         $("#product_offer_price_error").css({'display':'table'}).html("Product price cannot be 0");
         isvalid = false;
      }else if(parseInt(product_offer_price) > parseInt(product_price)){
         
        $('#product_offer_price').focus();
         $("#product_offer_price_error").css({'display':'table'}).html("Offer price should not be greater than product original price");
         isvalid = false;
      }
    }
    
    if(deliveryTimeline == '0') {
      $('#delivery_timeline').focus();
      $("#delivery_timeline_error").css({'display':'table'}).html("Please select delivery timeline");
      isvalid = false;
    }

    if(weight == '0') {
      $('#product_weight').focus();
      $("#weight_error").css({'display':'table'}).html("Please select weight");
      isvalid = false;
    }
    if(quantity == "" ) {
      $('#quantity').focus()
      $("#quantity_error").css({'display':'table'}).html("Please enter the quantity");
      isvalid = false;
    }else if(!$.isNumeric(quantity)) {
      $('#quantity').focus();
      $("#quantity_error").css({'display':'table'}).html("Please enter the valid quantity number ex: 1 or 12");
      isvalid = false;
    }
    if(product_description == ""){
      $('#product_description_error').focus();
      $("#product_description_error").css({'display':'table'}).html("Please add description");
      
      isvalid = false;
    }
    
     var selectProdutType = document.getElementById('product_type');
      if (!selectProdutType.value) {
        $('#product_type_error').css({'display':'table'}).html("Please select a product type");
          isvalid = false;     
      } 
   /* if(product_label > 0){
      
      $('#product_label').focus();
      $("#product_label_error").css({'display':'table'}).html("Please add label of one word");
         return false;
    
    } */
    //making it non mandatory
  /*  if(product_tags == ""){
      $('#product_tags_error').focus();
      $("#product_tags_error").css({'display':'table'}).html("Please choose some tags");
      return false;
    } */

    if(product_size == ""){
      $('#size').focus();
      $("#size_error").css({'display':'table'}).html("Please enter dimensions available for your product");
     // return false;
      isvalid = false;
    } 
    if(product_color == ""){
       $('#color').focus();
       $("#color_error").css({'display':'table'}).html("Please enter color/s for your product");
    // return false;
      isvalid = false;
    }
  
    if(product_material == ""){
      $('#material').focus();
      $("#material_error").css({'display':'table'}).html("Please add product material/charm etc");
  // return false;
      isvalid = false;
    }
 
    if (!alphaNumericFormat.test(product_sku)  && product_sku != "" ) {
        $('#sku').focus();
        $("#sku_error").html("Please enter valid stock keep unit having alphabets and numeric value").fadeIn();
     //return false;
      
      isvalid = false;
      }  else if (product_sku != "" && product_sku.length >= 11 ) {
        $('#sku').focus();
        $("#sku_error").html("Please enter sku value of lenghth less than 10").fadeIn();
    // return false;
        isvalid = false;
      }
    return isvalid;
  }

  // Show product details tab
  $('.toggel_product_div').click(function () {
    $('.image_upload_div').hide();
    $('.product_details_div').fadeIn();
  });

  // Show product details tab
  $('.toggel_image_div').click(function (e){
    e.preventDefault();
    //Validating values
    if(productValidation()) {
      $(".error_tag").hide();
      $('.product_details_div').hide();
      $('.image_upload_div').fadeIn();
    }
  });
  
  // Show product details tab
  $('.product_submit').click(function (e){
    e.preventDefault();
    if(validateProductImages() && validateAgreement()) {
      $(".loding_container").show();
      setTimeout(function() { $('#add_product_form').submit();
                            }, 100);
    }
  });
  
  
  //Opening modal window on click of button
  $('.seller_add_product').click(function (){
    var seller_required_information = readCookie('seller_required_information');
    if(seller_required_information != "incomplete"){
      var addProductPopup = $('.add_product_popup');
      var emailId = readCookie('seller_email');
      var sessionId = readCookie('session_token');
      $('.seller_email').val(emailId);
      $('.seller_session_id').val(sessionId);
        $('.product_tags').dropdown({allowAdditions: true});
      addProductPopup.bPopup({
        positionStyle: 'fixed',
        scrollBar: 'true',
        closeClass: 'modal__close'
      });
    } else {
      alert('Please update your profile details to add products');
      $('#seller_profile_edit_button').click();
    }
  });
  
  //Saving new product data
  $("form#add_product_form").submit(function(e){
    e.preventDefault();
    $(".loding_container").fadeIn();
    var addProductSubmitBtn = $('#add_product_submit');  // submit button
    addProductSubmitBtn.html('Saving...');
    addProductSubmitBtn.prop('disabled', true); // disable button
    addProductSubmitBtn.attr("disabled", true); // disable button
    var formData = new FormData($("#add_product_form")[0]);

    //Adding all product image url's
    for (var i = 0; i < product_img_arr.length; i++) {
      formData.append('upload_img_url[]',product_img_arr[i]);
    }
    $.ajax({
      url: "https://test-designers.lovethisstuff.com/website/product/saveProductAPI",
      type: 'POST',
      data: formData,
      processData: false,
      async: false,
      beforeSend: function() {
        addProductSubmitBtn.html('Saving ...');
        addProductSubmitBtn.prop('disabled', true); // disable button
        addProductSubmitBtn.attr('disabled', true); // disable button
      },
      success: function (data) {
        $(".loding_container").fadeOut();
        if(data.messageType === "SUCCESS") {
          addProductSubmitBtn.html('Saved');
          addProductSubmitBtn.prop('disabled', true); // disable button
          addProductSubmitBtn.attr('disabled', true); // disable button
          $('.api_error').hide();
          $('.api_success').hide();
          $('.add_product_success').html(data.message).fadeIn();
          setTimeout(function(){location.reload();},700);
        } else if(data.messageType === "SESSION_EXPIRED" || data.messageType === "UNAPPROVED") {
          addProductSubmitBtn.html('Submit'); // change submit button text
          addProductSubmitBtn.attr('disabled', false); // disable button
          $('.api_error').hide();
          $('.api_success').hide();
          $('.add_product_error').html(data.message).fadeIn();
        }
      },
      error : function (data) {
        $(".loding_container").fadeOut();
        addProductSubmitBtn.html('Submit'); // change submit button text
        addProductSubmitBtn.attr("disabled", false); // Enabling button
        addProductSubmitBtn.prop('disabled', false); // disable button
        $('.api_error').hide();
        $('.api_success').hide();
        $('.add_product_error').html(data.message).fadeIn();
      },
      cache: false,
      contentType: false,
      processData: false
    });
    return false;
  });
  
  //Checking if the seller is logged in, then get the list of product types.
  if (readCookie('business_name') != null && $('#seller_name').length 
      && readCookie('business_name')==$('#seller_name').val() ){
      $.ajax({ 
          type: 'GET', 
          url: 'https://test-designers.lovethisstuff.com/website/Product/getTheListOfProductTypes', 
          data: "", 
          dataType: 'json',
          success: function (data) { 
            if(data.messageType === "SUCCESS") {
			var options = '<option value="" selected="" disabled="">Select your product type *</option><option value ="Other"> OTHER</option>';
              $.each(data.product_types, function(i, optionHtml){
                options += '<option value ="' + optionHtml.ProductTypes.type + '">' + optionHtml.ProductTypes.type + '</option>';
           	  });
               $("#product_type").append(options);
               $("#update_product_type").append(options);
               $("duplicate_product_type").append(options);
            }
          },
          error : function (data) {
          },
          cache: false,
          contentType: false,
          processData: false
      });
  }
  
});